import '../util/Plaintext.Util';

const PARENT_WRAP_CLASS = 'pt-expanderWrap';
const TARGET_WRAP_CLASS = 'pt-expanderTargetWrap';

class Expander {
  transitionEndCallback = null
  
  /**
   * @param el DOMNode An element with an aria-controls property
   */
  constructor(el) {
    this.toggleEl = el;
    this.toggleEl.addEventListener('click', this.handleToggleClick.bind(this));
    
    const controlsId = el.getAttribute('aria-controls');
    const targetEl = this.targetEl = document.getElementById(controlsId);
    this.targetWrapEl = targetEl.closest(`.${ TARGET_WRAP_CLASS }`);
    
    this.wrapEl = el.closest(`.${ PARENT_WRAP_CLASS }`);
  }
  
  handleToggleClick(e) {
    this.toggle();
  }
  
  toggle(expand = null) {

    expand = (expand !== null) ? expand : !this.isExpanded();
    this.toggleEl.setAttribute('aria-expanded', expand ? 'true' : 'false');
    this.targetEl.setAttribute('aria-hidden', expand ? 'false' : 'true');

    if (expand) {
      this.dispatch('Expanding');
      this.targetWrapEl.style.maxHeight = window.Plaintext.Util.calcHeight(this.targetEl) + 'px';
      
      this.onTransitionEnd(() => {
        this.targetWrapEl.style.maxHeight = '';
        this.dispatch('Expanded');
      });
    }
    else {
      this.dispatch('Collapsing');
      
      this.targetWrapEl.style.maxHeight = this.targetEl.offsetHeight + "px";
      
      window.setTimeout(() => {
        this.targetWrapEl.style.maxHeight = "0";
        
        this.onTransitionEnd(()  => { 
          this.targetWrapEl.style.maxHeight = '';
          this.dispatch('Collapsed');
        });
      }, 1);
    }
    
    window.setTimeout(() => { 
      this.wrapEl && this.wrapEl.classList.toggle('pt-expanderWrap--open', expand);
    }, 2);
  }
  
  isExpanded() {
    return this.toggleEl.getAttribute('aria-expanded') !== 'false';
  }
  
  dispatch(eventType) {
    const eventDetail = { expander: this };
    const e = new CustomEvent(`Plaintext.Expander.${ eventType }`, { detail: eventDetail, bubbles: true });
    this.toggleEl.dispatchEvent(e);
  }
  
  onTransitionEnd(cb) {
    const options = { once: true };
    this.transitionEndCallback && this.targetWrapEl.removeEventListener(this.transitionEndCallback, options);
    this.transitionEndCallback = cb;
    this.targetWrapEl.addEventListener('transitionend', cb, options);
  }
}

Expander.init = function() {
  document.querySelectorAll('.pt-expanderToggle').forEach(el => new Expander(el));
}

window.Plaintext = window.Plaintext || {};
window.Plaintext.Expander = Expander;
export default Expander;



/**
 * Copyright 2023 Plaintext Inc.
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
